// extracted by mini-css-extract-plugin
var _1 = "col-kHz3Q";
var _2 = "label-Q8h7j";
export { _1 as "col", _2 as "label" }
